import React from "react";
import "./op-code-survey-styles.css";

const OpCodeSurvey = () => {
    return <div>OpCodeSurvey</div>;
};

export default OpCodeSurvey;
